import { render, staticRenderFns } from "./ChiTiet.vue?vue&type=template&id=277558da&scoped=true&"
import script from "./ChiTiet.vue?vue&type=script&lang=js&"
export * from "./ChiTiet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277558da",
  null
  
)

export default component.exports